























import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import dayjs from 'dayjs';

@Component
export default class DatePicker extends Vue {
    @Prop(String) initialDate?: string;
    year = dayjs(this.initialDate).year();
    month = dayjs(this.initialDate).month() + 1;
    date = dayjs(this.initialDate).date();

    get years() {
        const endYear = dayjs().year();
        let y = 1970;
        const result: number[] = [];
        while (y <= endYear) {
            result.push(y);
            y++;
        }
        return result;
    }

    get days(): number {
        const d = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        // 判断是否为闰年
        if ((this.year % 4 === 0 && this.year % 100 !== 0) || (this.year % 100 === 0 && this.year % 400 === 0)) {
            if (this.month === 2) {
                return 29;
            } else {
                return d[this.month - 1];
            }
        } else {
            return d[this.month - 1];
        }
    }

    beautify(m: number) {
        return m < 10 ? '0' + m.toString() : m.toString();
    }

    @Watch('year')
    onYearChange(year: number) {
        this.$emit('update:year', year);
    }

    @Watch('month')
    onMonthChange(month: number) {
        this.$emit('update:month', month);
    }

    @Watch('date')
    onDateChange(date: number) {
        this.$emit('update:date', date);
    }
}
